module.exports = __webpack_public_path__ + "img/product-category-engagementrings@2x.0b7d67e.jpg";